import { ActionCreator, AnyAction, Action } from 'redux';
import { RootState } from '../modules';
import axios from 'axios';
import { getOffDays, getLookaheadLength, getSelectedPhasePlanId } from "../selectors/phaseplan.selector";
import { getProjectId } from "../selectors/project.selector";
import { alertActions } from "./alert.actions";
import { getSelectedLookaheadId, getSelectedLookaheadTags, getLookaheadTagsList, getActiveCommitment, getVarianceUpdates, getLookaheadTags, getSelectedLookahead, getSelectedRows, getRowGroups, getLocalRowGroupStarts, getRowGroupStarts, getMilestoneKeys, getAllLookaheadTags, getUndoCommands } from "../selectors/lookahead.selector";
import { getFirebase } from "react-redux-firebase";
import { constants } from '../constants/global.constants';
import { LookaheadTag, LookaheadTagStatus } from '../models/LookaheadTag'
import { ThunkDispatch } from 'redux-thunk';
import { refUpdate, refSave, clean } from './entity.actions';
import { isSelectMultiPressed } from '../selectors/util.selector';
import { batch } from 'react-redux';
import { TagType, SelectedTag } from '../models/ TagType';
import { getDbFromTagType, TagsChangesInterface, TagChangeInterface, VarianceTagChangeInterface } from './phaseplan.actions';
import { dialogActions } from './dialog.actions';
import moment from 'moment'
import { Variance } from '../utils/Variance';
import { HuddleFilter } from '../modules/lookahead.reducer';
import { LookAheadStatuses } from '../containers/helpers/AllTasksScreen';
import { PullOrPush } from '../utils/PullOrPush';
import { isAdmin } from '../selectors/user.selector';
import { BatchData } from '../models/BatchData';
import { getBatchIds } from '../selectors/dialog.selector';
import { homeActions } from './home.actions';
import { uiActions } from './ui.actions';
import bugsnagClient from '../utils/BugSnagClient';
import { RowGroup } from '../models/Lookahead';
import { UndoCommand } from '../models/UndoCommand';
import { Constraint } from '../models/Constraint';
import { addRowGroupFunc, deleteRowGroupFunc, moveGroupFunc } from './lookahead.actions.helper';
import { dockPadEntityMapToList } from '../containers/DockPadFormTemplates';

const _ = require('lodash');

export const LOOKAHEAD_TAG_DIALOG_OPEN = 'LOOKAHEAD_TAG_DIALOG_OPEN'
export const LOOKAHEAD_TAG_DIALOG_CLOSE = 'LOOKAHEAD_TAG_DIALOG_CLOSE'

export const LOOKAHEAD_SELECTED = 'LOOKAHEAD_SELECTED'

export const LOOKAHEAD_SELECTED_TAGS_CLEARED = 'LOOKAHEAD_SELECTED_TAGS_CLEARED'
export const LOOKAHEAD_TAGS_SELECTED = 'LOOKAHEAD_TAGS_SELECTED'

export const LOOKAHEAD_HISTOGRAM_TOGGLE = 'LOOKAHEAD_HISTOGRAM_TOGGLE'

export const SHOW_VARIANCE_DIALOG = 'SHOW_VARIANCE_DIALOG';
export const CLOSE_VARIANCE_DIALOG = 'CLOSE_VARIANCE_DIALOG'
export const SHOW_DELETE_PPC_DIALOG = 'SHOW_DELETE_PPC_DIALOG';
export const CLOSE_DELETE_PPC_DIALOG = 'CLOSE_DELETE_PPC_DIALOG';

export const HUDDLE_FILTER = 'HUDDLE_FILTER'
export const SELECT_PPC_COMMITMENT = 'SELECT_PPC_COMMITMENT'
export const MAKE_READY_PLAN_FILTER_BY_TRADE = 'MAKE_READY_PLAN_FILTER_BY_TRADE'
export const ON_ROW_SELECT = 'ON_ROW_SELECT'
export const ON_ROW_DESELECT = 'ON_ROW_DESELECT'
export const ON_COLUMN_SELECT = 'ON_COLUMN_SELECT'
export const TOGGLE_ROW_GROUP = 'TOGGLE_ROW_GROUP'
export const REMOVE_ROW_GROUP = 'REMOVE_ROW_GROUP'
export const LOOKAHEAD_FORCE_REFRESH = 'LOOKAHEAD_FORCE_REFRESH'
export const LOOKAHEAD_FORCE_REFRESH_CLEAR = 'LOOKAHEAD_FORCE_REFRESH_CLEAR'
export const ON_ROW_UNSELECT = 'ON_ROW_UNSELECT'
export const ON_ADD_UNDO_COMMAND = 'ON_ADD_UNDO_COMMAND'
export const ON_CLEAR_UNDO_COMMAND = 'ON_CLEAR_UNDO_COMMAND'
export const ON_SHIFT_UNDO_COMMAND = 'ON_SHIFT_UNDO_COMMAND'
export const HUDDLE_FILTER_UP = 'HUDDLE_FILTER_UP'
export const HUDDLE_FILTER_DOWN = 'HUDDLE_FILTER_DOWN'
export const VIEW_REPORT_OPEN = 'VIEW_REPORT_OPEN'
export const VIEW_REPORT_CLOSE = 'VIEW_REPORT_CLOSE'
export const INCREASE_BOARD_SIZE = 'INCREASE_BOARD_SIZE'
export const DECREASE_BOARD_SIZE = 'DECREASE_BOARD_SIZE'


interface IncreasedBoardSizeAction extends Action {
    type: 'INCREASE_BOARD_SIZE'
    payload: {
    }
}

interface DecreaseBoardSizeAction extends Action {
    type: 'DECREASE_BOARD_SIZE'
    payload: {
    }
    
}

const increaseBoardSize: ActionCreator<IncreasedBoardSizeAction> = () => ({
    type: 'INCREASE_BOARD_SIZE',
    payload: {
    },
    meta: {
        debounce: {
            time: 500,
            leading: true, 
            trailing: false
        }
    }
})

const decreaseBoardSize: ActionCreator<DecreaseBoardSizeAction> = () => ({
    type: 'DECREASE_BOARD_SIZE',
    payload: {
    },
    meta: {
        debounce: {
            time: 500,
            leading: true, 
            trailing: false
        }
    }
})



interface OnAddUndoCommandAction extends Action {
    type: 'ON_ADD_UNDO_COMMAND'
    payload: {
        command: UndoCommand
    }
}

const onAddUndoCommand: ActionCreator<OnAddUndoCommandAction> = (command: UndoCommand) => ({
    type: ON_ADD_UNDO_COMMAND,
    payload: {
        command
    }
})



interface OnShiftUndoCommandAction extends Action {
    type: 'ON_SHIFT_UNDO_COMMAND'
    payload: {
    }
}

const onShiftUndoCommand: ActionCreator<OnShiftUndoCommandAction> = () => ({
    type: ON_SHIFT_UNDO_COMMAND,
    payload: {
        
    }
})

interface OnClearUndoCommandAction extends Action {
    type: 'ON_CLEAR_UNDO_COMMAND'
    payload: {
    }
}

const onClearUndoCommand: ActionCreator<OnClearUndoCommandAction> = () => ({
    type: ON_CLEAR_UNDO_COMMAND,
    payload: {
        
    }
})

interface OnColumnSelectAction extends Action {
    type: 'ON_COLUMN_SELECT'
    payload: {
        column: string
    }
}

const onColumnSelect: ActionCreator<OnColumnSelectAction> = (column: string) => ({
    type: ON_COLUMN_SELECT,
    payload: {
        column
    }
})


interface OnRowSelectAction extends Action {
    type: 'ON_ROW_SELECT'
    payload: {
        row: number
    }
}

const onRowSelect: ActionCreator<OnRowSelectAction> = (row: number) => ({
    type: ON_ROW_SELECT,
    payload: {
        row
    }
})

interface OnRowDeSelectAction extends Action {
    type: 'ON_ROW_DESELECT'
    payload: {
    }
}

const onRowDeSelect: ActionCreator<OnRowDeSelectAction> = () => ({
    type: ON_ROW_DESELECT,
    payload: {
        
    }
})


interface OnRowUnSelectAction extends Action {
    type: 'ON_ROW_UNSELECT'
    payload: {
    }
}

const onRowUnSelect: ActionCreator<OnRowUnSelectAction> = (row: number) => ({
    type: ON_ROW_UNSELECT,
    payload: {
        row
    }
})

interface ToggleRowGroupAction extends Action {
    type: 'TOGGLE_ROW_GROUP'
    payload: {
        row: number
    }
}

interface RemoveClosedRowAction extends Action {
    type: 'REMOVE_ROW_GROUP',
    payload: {
        row: number
    }
}

const onRemoveClosedRowGroup: ActionCreator<RemoveClosedRowAction> = (row: number) => ({
    type: 'REMOVE_ROW_GROUP',
    payload: {
        row
    }
})



const onToggleRowGroup: ActionCreator<ToggleRowGroupAction> = (row: number) => ({
    type: TOGGLE_ROW_GROUP,
    payload: {
        row
    }
})


interface LookaheadSelectedAction extends Action {
    type: 'LOOKAHEAD_SELECTED'
    payload: {
        lookaheadId: string
    }
}

const lookaheadSelected: ActionCreator<LookaheadSelectedAction> = (lookaheadId: string) => ({
    type: LOOKAHEAD_SELECTED,
    payload: {
        lookaheadId
    }
})

interface LookaheadTagDialogOpenAction extends Action {
    type: 'LOOKAHEAD_TAG_DIALOG_OPEN',
    payload: {
        tagId?: string,
        isMilestone?: boolean,
    }
}

interface ViewReportDialogOpenAction extends Action {
    type: 'VIEW_REPORT_OPEN',
    payload: {
        tradeId?:string,
        reportDate?: string
    }
}

interface ViewReportDialogCloseAction extends Action {
    type: 'VIEW_REPORT_CLOSE',
    payload: {
        
    }
}


interface LookaheadTagDialogCloseAction extends Action {
    type: 'LOOKAHEAD_TAG_DIALOG_CLOSE',
    payload: {

    }
}

interface LookaheadTagsSelectedAction extends Action {
    type: 'LOOKAHEAD_TAGS_SELECTED',
    payload: {
        tags: Record<string, SelectedTag>
    }
}

interface LookaheadForceRefreshAction extends Action {
    type: 'LOOKAHEAD_FORCE_REFRESH',
    payload: {
        column: string
    }
}

interface LookaheadForceRefreshResetAction extends Action {
    type: 'LOOKAHEAD_FORCE_REFRESH_CLEAR',
    payload: {
    }
}


interface LookaheadSelectedTagsClearedAction extends Action {
    type: 'LOOKAHEAD_SELECTED_TAGS_CLEARED',
    payload: {
    }
}

interface LookaheadHistogramToggle extends Action {
    type: 'LOOKAHEAD_HISTOGRAM_TOGGLE',
    payload: {

    }
}

interface ShowDeletePPCDialog extends Action {
    type: 'SHOW_DELETE_PPC_DIALOG',
    payload: {
        deletePPCId: string
    }

}

interface CloseDeletePPCDialog extends Action {
    type: 'CLOSE_DELETE_PPC_DIALOG',
    payload: {
    }
}

interface ShowVarianceDialog extends Action {
    type: 'SHOW_VARIANCE_DIALOG',
    payload: {
        update: Record<string, VarianceTagChangeInterface>
    }

}

interface CloseVarianceDialog extends Action {
    type: 'CLOSE_VARIANCE_DIALOG',
    payload: {

    }
}

interface SelectPPCCommitment extends Action {
    type: 'SELECT_PPC_COMMITMENT',
    payload: {
        selectedCommitmentId: string
    }
}

interface HuddleFilterChange extends Action {
    type: 'HUDDLE_FILTER',
    payload: {
        filter: HuddleFilter
    }
}

interface HuddleFilterUp extends Action {
    type: 'HUDDLE_FILTER_UP',
    payload: {
    }
}


interface HuddleFilterDown extends Action {
    type: 'HUDDLE_FILTER_DOWN',
    payload: {
    }
}

interface MakeReadyPlanFilterByTradeAction extends Action {
    type: 'MAKE_READY_PLAN_FILTER_BY_TRADE';
    payload: {
        trade: Trade | null; 
    }
}

const makeReadyPlanFilterByTrade: ActionCreator<MakeReadyPlanFilterByTradeAction> = (
    trade: Trade | null 
) => ({
    type: MAKE_READY_PLAN_FILTER_BY_TRADE,
    payload: {
        trade: trade
    }
})

const huddleFilterChange: ActionCreator<HuddleFilterChange> = (filter: HuddleFilter) => ({
    type: HUDDLE_FILTER,
    payload: {
        filter
    }
})

const huddleFilterUp: ActionCreator<HuddleFilterUp> = () => ({
    type: HUDDLE_FILTER_UP,
    payload: {
        
    }
})

const huddleFilterDown: ActionCreator<HuddleFilterDown> = () => ({
    type: HUDDLE_FILTER_DOWN,
    payload: {
        
    }
})


const selectPPCCommitment: ActionCreator<SelectPPCCommitment> = (selectedCommitmentId: string) => ({
    type: SELECT_PPC_COMMITMENT,
    payload: {
        selectedCommitmentId
    }
})

const showDeletePPCDialog: ActionCreator<ShowDeletePPCDialog> = (commitmentId: string) => ({
    type: SHOW_DELETE_PPC_DIALOG,
    payload: {
        deletePPCId: commitmentId
    }
})

const closeDeletePPCDialog: ActionCreator<CloseDeletePPCDialog> = () => ({
    type: CLOSE_DELETE_PPC_DIALOG,
    payload: {
        
    }
})

const showVarianceDialog: ActionCreator<ShowVarianceDialog> = (update: Record<string, VarianceTagChangeInterface>) => ({
    type: SHOW_VARIANCE_DIALOG,
    payload: {
        update
    }
})

const closeVarianceDialog: ActionCreator<CloseVarianceDialog> = () => ({
    type: CLOSE_VARIANCE_DIALOG,
    payload: {
        
    }
})

const lookaheadDialogOpen: ActionCreator<LookaheadTagDialogOpenAction> = (tagId?: string, isMilestone?:boolean, tagDate?: string, row?:number) => ({
    type: LOOKAHEAD_TAG_DIALOG_OPEN,
    payload: {
        tagId,
        isMilestone,
        tagDate,
        row
    }
})

const lookaheadDialogClose: ActionCreator<LookaheadTagDialogCloseAction> = () => ({
    type: LOOKAHEAD_TAG_DIALOG_CLOSE,
    payload: {

    }
})

const openReportDialog: ActionCreator<ViewReportDialogOpenAction> = (tradeId?: string, reportDate?: string) => ({
    type: VIEW_REPORT_OPEN,
    payload: {
        tradeId,
        reportDate
    }
})

const closeReportDialog: ActionCreator<ViewReportDialogCloseAction> = () => ({
    type: VIEW_REPORT_CLOSE,
    payload: {
    }
})



const lookaheadTagsSelectedAction: ActionCreator<LookaheadTagsSelectedAction> = (tags: Record<string, SelectedTag>) => ({
    type: LOOKAHEAD_TAGS_SELECTED,
    payload: {
        tags: tags
    }
})

const lookaheadSelectedTagsClearAction: ActionCreator<LookaheadSelectedTagsClearedAction> = () => ({
    type: LOOKAHEAD_SELECTED_TAGS_CLEARED,
    payload: {
    }
})

const lookaheadHistogramToggle: ActionCreator<LookaheadHistogramToggle> = () => ({
    type: LOOKAHEAD_HISTOGRAM_TOGGLE,
    payload: {

    },
    meta: {
        debounce: {
            time: 100
        }
    }
})



const lookaheadForceRefresh: ActionCreator<LookaheadForceRefreshAction> = (column: string) => ({
    type: LOOKAHEAD_FORCE_REFRESH,
    payload: {
        column
    }
})

const lookaheadForceRefreshAsync = (column:string) => {
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => RootState) => {
        
        dispatch(lookaheadForceRefresh(column))
    }
}


const lookaheadForceRefreshReset: ActionCreator<LookaheadForceRefreshResetAction> = () => ({
    type: LOOKAHEAD_FORCE_REFRESH_CLEAR,
    payload: {
        
    }
})

export type LookaheadAction = LookaheadSelectedAction 
| LookaheadTagDialogOpenAction 
| LookaheadTagDialogCloseAction
| LookaheadTagsSelectedAction
| LookaheadSelectedTagsClearedAction
| LookaheadHistogramToggle



const lookaheadSelectedTagsClearActionAsync = () => {
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => RootState) => {
        if(!_.isEqual(getSelectedLookaheadTags(getState()), {}))
            dispatch(lookaheadSelectedTagsClearAction())
    }
}

const lookaheadTagsSelectedActionAsync = (tags: Record<string, SelectedTag>) => {
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => RootState) => {
        dispatch(lookaheadTagsSelectedAction(tags))
    }
}

const startLookaheadPlan = () => {
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => RootState) => {
        const state = getState()

        // Check all locations have milestones
        const offDays = getOffDays(state)
        
        const phasePlanId = getSelectedPhasePlanId(state)
        const projectId = getProjectId(state)

        try {
            await axios.post(`https://us-central1-constructionapp-c3a95.cloudfunctions.net/import_plangrid_projects`, {
                offDays: Array.from<number>(offDays),
                projectId: projectId,
                phaseplanId: phasePlanId
            })
            dispatch(alertActions.success('Make Ready Plan Started'))

        } catch (e) {
            dispatch(alertActions.error('Make Ready Plan Started Error'))

        }


        return
    }
}

const saveBatch = (batchData:BatchData) => {
    const firebase = getFirebase();
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => RootState) => {
        const state = getState()
        const projectId = getProjectId(state)
        const lookaheadId = getSelectedLookaheadId(state)
        const batchIds: Record<string, SelectedTag> = getBatchIds(state)

        const entityRoute = `/projects/${projectId}/lookaheads/${lookaheadId}/tags/`;
        
        const tagChanges = batchData

        const updates: Record<string, object> = {}

        Object.keys(batchIds).forEach(batchId => {
            Object.keys(tagChanges).forEach(keyValue => {
                updates[`${entityRoute}${batchId}/${keyValue}`] = tagChanges[keyValue]
            })
        })
        
        dispatch(homeActions.openCircularProgressLoading());


        return firebase.database().ref().update({...updates}).then(() => {
            dispatch(dialogActions.batchDialogClose())
            dispatch(homeActions.closeCircularProgressLoading());
            dispatch(lookaheadSelectedTagsClearAction())


            dispatch(alertActions.success('Saved'))
          }).catch(e => {
            console.error(e)
            dispatch(dialogActions.batchDialogClose())
            dispatch(homeActions.closeCircularProgressLoading());
            dispatch(alertActions.error('Error Saving'))
        })

    }
}

const createMRP = (name: string) => {
    const firebase = getFirebase();

    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => RootState) => {
        const state = getState()
        const projectId = getProjectId(state)
        const offDays = getOffDays(state)

        const entityRoute = `/projects/${projectId}/lookaheads/`;
        const ref = firebase.database().ref(entityRoute);

        const newId = ref.push().key;

        firebase.database().ref(`${entityRoute}/${newId}`).update({
            name: name,
            offDays: Array.from<number>(offDays),
            phaseplanId: 'none'
        })
    }
}

const saveTag = (tag: LookaheadTag, newConstraints: Record<string, object>, tagId?: string, tagDate?: string | null, row?: number | null, duration?: number | null) => {
    const firebase = getFirebase();
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => RootState) => {

        const state = getState()
        const projectId = getProjectId(state)
        const lookaheadId = getSelectedLookaheadId(state)
        const milestoneKeys = getMilestoneKeys(state)
        delete tag['uid']
        delete tag['dayOffset']
        delete tag['tagCardType']
        delete tag['tableData']
        delete tag['tagType']

        const entityRoute = `/projects/${projectId}/lookaheads/${lookaheadId}/tags/`;
        const entityMilestoneRoute = `/projects/${projectId}/lookaheads/${lookaheadId}/milestone_tags/`;

        let updateFunc = refUpdate
        let saveType = 'update'

        const updates: Record<string, object> = {}

        if(!tagDate && !duration){
            if (!tag.isMilestone) {
                let newTagId:string = tagId
                const ref = firebase.database().ref(entityRoute);

                if (!newTagId) {
                    newTagId = ref.push().key
                    updateFunc = refSave
                    saveType = 'save'
                }
                updates[`${entityMilestoneRoute}${newTagId}`] = null;
                updates[`${entityRoute}${newTagId}`] = tag    
            } else {
                let newTagId:string = tagId
                const ref = firebase.database().ref(entityMilestoneRoute);
                        
                if (!newTagId) {
                    newTagId = ref.push().key
                    updateFunc = refSave
                    saveType = 'save'
                }
                updates[`${entityRoute}${newTagId}`] = null;
                updates[`${entityMilestoneRoute}${newTagId}`] = tag
            }
        }

        if( !!tagDate && !!duration && row != null && row != undefined && row >= 0) {
            const date = moment(tagDate, 'l')
            if(date.isValid()) {
                Array(duration).fill(1).map((i, index) => {
                    const newDate = moment(tagDate, 'l')

                    let newTagId:string = tagId
                    const ref = firebase.database().ref(entityRoute);
                    if (!newTagId) {
                        newTagId = ref.push().key;
                        updateFunc = refSave
                        saveType = 'save'
                    }

                    const newTag = {...tag}
                    newTag.tagDate = newDate.add(index, 'days').format('l')
                    newTag.indexId = row
                    delete newTag['isMilestone']
                    updates[`${entityRoute}${newTagId}`] = newTag   
                })
            }
        }
        
        dispatch(addTagLoading());

        const commitments = getActiveCommitment(state)

        //check for commitments
        delete tag['isMilestone']

        firebase.database().ref().update({ ...updates })
        .then(() => {
            dispatch(addTagStopLoading());
        })
        .catch((e: Error) => {
            console.error('error saving tags', tag, updates, e)

            dispatch(alertActions.error('Error Saving trade'));
            dispatch(addTagStopLoading());
            bugsnagClient.notify(e)

        });
        
        return tagId

    };

    function addTagLoading() {
        return {
            type: constants.ADD_LOOKAHEAD_TAG_LOADING,
               
        };
    }

    function addTagStopLoading() {
        return {
            type: constants.ADD_LOOKAHEAD_TAG_STOP_LOADING,
               
        };
    }
}

const saveTagIsMilestone = (tag: LookaheadTag, newConstraints: Record<string, object>,  tagId?: string) => {
    const firebase = getFirebase();
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => RootState) => {

        const state = getState()
        const projectId = getProjectId(state)
        const lookaheadId = getSelectedLookaheadId(state)
        delete tag['uid']
        delete tag['dayOffset']
        delete tag['tagCardType']
        delete tag['tableData']
        delete tag['isMilestone']
        delete tag['crewSize']
        delete tag['tagType']



        const entityRoute = `/projects/${projectId}/lookaheads/${lookaheadId}/milestone_tags/`;

        const ref = firebase.database().ref(entityRoute);
        
        let newTagId:string = tagId
        if (!newTagId) {
            newTagId = ref.push().key;
        }

        const updates: Record<string, object> = {}
        updates[`${entityRoute}${newTagId}`] = tag

        dispatch(addTagLoading());
       
        firebase.database().ref().update(updates)
        .then(() => {
            dispatch(addTagStopLoading());
        })
        .catch((e: Error) => {
            console.error('error saving tags', tag, updates, e)

            dispatch(alertActions.error('Error Saving trade'));
            dispatch(addTagStopLoading());
            bugsnagClient.notify(e)

        });
        

        
        return newTagId


    };

    function addTagLoading() {
        return {
            type: constants.ADD_LOOKAHEAD_TAG_LOADING,
               
        };
    }

    function addTagStopLoading() {
        return {
            type: constants.ADD_LOOKAHEAD_TAG_STOP_LOADING,
               
        };
    }
}

const goToLookahead = (lookaheadId: string) => {
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => RootState) => {

    }
}

const changeLookaheadTagColumn = (changes: TagsChangesInterface) => {
    const firebase = getFirebase();
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => RootState) => {

        const state = getState()
        const projectId = getProjectId(state)
        const lookaheadId = getSelectedLookaheadId(state)

        const commitment = getActiveCommitment(state)
        const milestoneKeys = getMilestoneKeys(state)

        const updates: Record<string, string | number> = {}
        const needsVarianceUpdates: Record<string, VarianceTagChangeInterface> = {}

        Object.entries(changes).filter(([key, value]) => !(!!commitment && !!commitment.commitLog[key])).forEach(([key, value]) => {
            const { tagCardType, newColumn, newIndex } = value
            const isMilestoneTag = milestoneKeys.has(key);
            const tagType = getDbFromTagType(tagCardType, isMilestoneTag)

            updates[`/projects/${projectId}/lookaheads/${lookaheadId}/${tagType}/${key}/tagDate`] = newColumn
            updates[`/projects/${projectId}/lookaheads/${lookaheadId}/${tagType}/${key}/indexId`] = parseInt(newIndex ,10)
        })

        Object.entries(changes).filter(([key, value]) => (!!commitment && !!commitment.commitLog[key])).forEach(([key, value]) => {
            const { tagCardType, newColumn, newIndex } = value
            const tagType = getDbFromTagType(tagCardType)
            const commitId = commitment?.uid
            if(!!commitId) {
                needsVarianceUpdates[key] = {
                    newColumn: newColumn,
                    newIndex: parseInt(newIndex ,10),
                    tagCardType: tagCardType,
                    commitmentId: commitId
                }
            }

            //needsVarianceUpdates[`/projects/${projectId}/lookaheads/${lookaheadId}/${tagType}/${key}/tagDate`] = newColumn
            //needsVarianceUpdates[`/projects/${projectId}/lookaheads/${lookaheadId}/${tagType}/${key}/indexId`] = parseInt(newIndex ,10)
        })

        batch(() => {
            //dispatch(changeTagLoading());
            dispatch(updateColumns(changes))
            dispatch(lookaheadSelectedTagsClearAction())
        })

        //check for commitments
        if(Object.keys(needsVarianceUpdates).length > 0) {
            dispatch(showVarianceDialog(needsVarianceUpdates))
        }

        await firebase.database().ref().update(updates)
            .then(() => {
                //dispatch(changeTagStopLoading());
            })
            .catch((e: Error) => {
                console.error('error changing tags', e)

                dispatch(alertActions.error('Error Moving Tag'));
                //dispatch(changeTagStopLoading());
                bugsnagClient.notify(e)

            });


    };

    function updateColumns(changes: Record<string, number>) {
        return {
            type: constants.CHANGE_LOOKAHEAD_TAG_COLUMN,
            payload: changes
        }
    }

    function changeTagLoading() {
        return {
            type: constants.CHANGE_LOOKAHEAD_TAG_COLUMN_LOADING,
               
        };
    }

    function changeTagStopLoading() {
        return {
            type: constants.ADD_LOOKAHEAD_TAG_STOP_LOADING,
               
        };
    }
}

const deleteTagColumn = (changes: TagsChangesInterface) => {
    const firebase = getFirebase();

    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => RootState) => {

        const state = getState()
        const projectId = getProjectId(state)
        const lookaheadId = getSelectedLookaheadId(state)
        const milestoneKeys = getMilestoneKeys(state)

        const updates: Record<string, null> = {}
        Object.entries(changes).forEach(([key, value]) => {
            const { tagCardType } = value
            const isMilestoneTag = milestoneKeys.has(key)
            const tagType = getDbFromTagType(tagCardType, isMilestoneTag)

            updates[`/projects/${projectId}/lookaheads/${lookaheadId}/${tagType}/${key}/tagDate`] = null
        })
        //dispatch(changeTagLoading());
        firebase.database().ref().update({ ...updates })
            .then(() => {
                //dispatch(changeTagStopLoading());
            })
            .catch((e: Error) => {
                console.error('error changing tags', e)
                batch(() => {
                    dispatch(alertActions.error('Error Deleting Tag'));
                    //dispatch(changeTagStopLoading());
                    dispatch(lookaheadSelectedTagsClearAction())
                })
                bugsnagClient.notify(e)

            });
        return
    };

    function changeTagLoading() {
        return {
            type: constants.ADD_LOOKAHEAD_TAG_LOADING,
               
        };
    }

    function changeTagStopLoading() {
        return {
            type: constants.ADD_LOOKAHEAD_TAG_STOP_LOADING,
               
        };
    }
}

const onTagClicked = (event:any, tagId:string, selectedTag: SelectedTag) => {
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => RootState) => {

        const isSelectMultPressed = isSelectMultiPressed(getState())



        event.preventDefault();

        const selectedTags: Record<string, SelectedTag> = getSelectedLookaheadTags(getState())
        
        let newSelectedTags:Record<string, SelectedTag> = {...selectedTags}
        if(!isSelectMultPressed) {
            newSelectedTags = {}
        }

        if(!!newSelectedTags[tagId]) {
            delete newSelectedTags[tagId]

        } else {
            newSelectedTags[tagId] = selectedTag
        }



        dispatch(lookaheadTagsSelectedAction(newSelectedTags))
    }		
}

const onTagDoubleClicked = (event:any, tagId:string, isMilestone?:boolean, selectedTag: SelectedTag) => {
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => RootState) => {
        

        event.preventDefault();

        if(selectedTag.tagType === TagType.PhasePlan) {
            dispatch(dialogActions.showTagDialog(tagId))
        }

        if(selectedTag.tagType === TagType.Lookahead) {
            dispatch(lookaheadDialogOpen(tagId, isMilestone))
        }

        if(selectedTag.tagType === TagType.Constraint) {
            dispatch(dialogActions.openConstraintDialog(tagId))
        }
    }
}

export interface CommitmentEntry {
    originalDate: number,
    originalStatus: LookaheadTagStatus,
    actualDate?: number,
    actualStatus?: LookaheadTagStatus,
    variance?: string,
    uid?: string
}
export type CommitLog = Record<string, CommitmentEntry>

export enum  CommitmentStatus {
    WorkingOn='Working On',
    Done='Done',
}

 export interface Commitment {
    commitLog: CommitLog,
    status: CommitmentStatus,
    dateCreated: string,
    uid?: string,
    name?: string
    startDate?: string,
    endDate?:string
 }

export interface LookaheadCommitment  {
    commitments: Record<string, Commitment>
}

 export type LookaheadCommitmentLog = Record<string, LookaheadCommitment>

const savePromiseTags = (name: string, startDate:string, endDate:string, tags:LookaheadTag[]) => {
    const firebase = getFirebase();

    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => RootState) => {
        const state = getState()
        const projectId = getProjectId(state)
        const lookaheadId = getSelectedLookaheadId(state)
        
        if(tags.length <= 0) {
            dispatch(alertActions.error('No Tags Selected'))
        }

        const commitLog = tags.reduce((obj, tag) => {
            obj[tag.uid] = {
                originalDate: tag.tagDate,
                originalStatus: tag.status
            }
            return obj
        },  {} as CommitLog)

        const lookaheadCommitment:Commitment = {
            commitLog,
            status: CommitmentStatus.WorkingOn,
            dateCreated: moment().format('l'),
            startDate: startDate,
            endDate:endDate,
            name: name
        }


        const ref = firebase.database().ref();

        let newId = ref.push().key;


        const entityRoute = `/projects/${projectId}/lookahead_commitments/${lookaheadId}/commitments/${newId}`;


        return refSave(firebase, firebase.database().ref(entityRoute), lookaheadCommitment)
        
    }
}

const endActiveCommitment = () => {
    const firebase = getFirebase();

    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => RootState) => {

        const state = getState()
        const projectId = getProjectId(state)
        const lookaheadId = getSelectedLookaheadId(state)
        const activeCommitment = getActiveCommitment(state) as Commitment | undefined
        const tags = (!!getLookaheadTags(state) ? getLookaheadTags(state) : {}) as Record<string, LookaheadTag>
        
        if(!activeCommitment) {
            return
        }

        const updates: Record<string, string | number | object> = {}


        const commitmentId = activeCommitment?.uid

        Object.entries(activeCommitment.commitLog).forEach(([key, value]) => {
            
            const tag = tags[key] 
            if(!!tag)  {
                updates[`/projects/${projectId}/lookahead_commitments/${lookaheadId}/commitments/${commitmentId}/commitLog/${key}/actualStatus`] = !!tag.status && !!LookaheadTagStatus[tag.status] ? tag.status : LookaheadTagStatus.Todo
            }else {
                updates[`/projects/${projectId}/lookahead_commitments/${lookaheadId}/commitments/${commitmentId}/commitLog/${key}/actualStatus`] = LookaheadTagStatus.Todo
            }
        })


        updates[`/projects/${projectId}/lookahead_commitments/${lookaheadId}/commitments/${commitmentId}/status`] = CommitmentStatus.Done

        await firebase.database().ref().update(updates)
            .then(() => {
                //dispatch(changeTagStopLoading());
            })
            .catch((e: Error) => {
                console.error('error ending commitment', e)

                dispatch(alertActions.error('Error Ending Commitment'));
                //dispatch(changeTagStopLoading());
                bugsnagClient.notify(e)

        });
    }
}

const lockDownPlan = () => {
    const firebase = getFirebase();

    const updates: Record<string, boolean> = {}


    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => RootState) => {
        const state = getState()

        const lookahead = getSelectedLookahead(state)

        const projectId = getProjectId(state)
        const lookaheadId = getSelectedLookaheadId(state)

        const _isAdmin = isAdmin(state)

        if(!_isAdmin) {
            dispatch(alertActions.error('Only Admins Can Change Lock Status'));

            return
        }

        const isLockedDown = lookahead.isLockedDown

        updates[`/projects/${projectId}/lookaheads/${lookaheadId}/isLockedDown`] = !isLockedDown

        await firebase.database().ref().update(updates)
            .then(() => {
                if(isLockedDown) {
                    dispatch(alertActions.success('Plan Unlocked'));
                } else {
                    dispatch(alertActions.success('Plan Locked'));
                }
            })
            .catch((e: Error) => {
                console.error('error locking plan', e)

                dispatch(alertActions.error('Error Locking PLan'));
                bugsnagClient.notify(e)

                //dispatch(changeTagStopLoading());
        });
    }
}

const savePromiseTagsByDates = (startDate:number, endDate:number) => {
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => RootState) => {
        const lookaheadTagsList = getLookaheadTagsList(getState())

        const filterTags = lookaheadTagsList.filter((tag: LookaheadTag) => {
            const tagDate = moment(tag.tagDate,'l').startOf('day').valueOf()

            const sDate = moment(startDate).startOf('day').valueOf()
            const eDate = moment(endDate).startOf('day').valueOf()
            return tagDate >= sDate && tagDate <= eDate
        })

        dispatch(savePromiseTags(
            `${moment(startDate).startOf('day').format('l')} - ${moment(endDate).startOf('day').format('l')}`, 
        moment(startDate).startOf('day').format('l'), 
        moment(endDate).startOf('day').format('l'),filterTags))
    }
}

const saveVariance = (variance:Variance) => {
    const firebase = getFirebase();

    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => RootState) => {
        const state = getState()
        const varianceUpdate = getVarianceUpdates(state)
        const projectId = getProjectId(state)
        const lookaheadId = getSelectedLookaheadId(state)

        const updates: Record<string, string | number | object> = {}


        Object.entries(varianceUpdate).forEach(([key, value]) => {
            const { tagCardType, newColumn, newIndex, commitmentId } = value
            const tagType = getDbFromTagType(tagCardType)

            updates[`/projects/${projectId}/lookaheads/${lookaheadId}/${tagType}/${key}/tagDate`] = newColumn

            updates[`/projects/${projectId}/lookaheads/${lookaheadId}/${tagType}/${key}/indexId`] = parseInt(newIndex ,10)

            updates[`/projects/${projectId}/lookahead_commitments/${lookaheadId}/commitments/${commitmentId}/commitLog/${key}/variance`] = variance
            updates[`/projects/${projectId}/lookahead_commitments/${lookaheadId}/commitments/${commitmentId}/commitLog/${key}/actualDate`] = newColumn
        })

        
        await firebase.database().ref().update(updates)
            .then(() => {
                //dispatch(changeTagStopLoading());
            })
            .catch((e: Error) => {
                console.error('error changing tags', e)

                dispatch(alertActions.error('Error Saving Variance Tag'));
                //dispatch(changeTagStopLoading());
                bugsnagClient.notify(e)

            });
        
    }
}

const deleteCommitment = (commitmentId:string) => {
    const firebase = getFirebase();

    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => RootState) => {
        const state = getState()
        const projectId = getProjectId(state)
        const lookaheadId = getSelectedLookaheadId(state)

        const updates: Record<string, string | number | object | null> = {}

        updates[`/projects/${projectId}/lookahead_commitments/${lookaheadId}/commitments/${commitmentId}`] = null

        await firebase.database().ref().update(updates)
            .then(() => {

                //dispatch(changeTagStopLoading());
                dispatch(alertActions.success('Deleted Commitment'));

            })
            .catch((e: Error) => {

                console.error('error changing tags', e)
                dispatch(alertActions.error('Error Deleting Commitment'));
                bugsnagClient.notify(e)

            });
        
    }
}

const changeLookaheadTagStatus = (tagId:string, tagCardType: TagType, status: LookaheadTagStatus) => {
    const firebase = getFirebase();

    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => RootState) => {
        const state = getState()
        const projectId = getProjectId(state)
        const lookaheadId = getSelectedLookaheadId(state)

        const tagType = getDbFromTagType(tagCardType)

        const updates: Record<string, string | number | object> = {}

        updates[`/projects/${projectId}/lookaheads/${lookaheadId}/${tagType}/${tagId}/status`] = status

        await firebase.database().ref().update(updates)
            .then(() => {
                //dispatch(changeTagStopLoading());
            })
            .catch((e: Error) => {
                console.error('error changing tags', e)

                dispatch(alertActions.error('Error Moving Tag'));
                //dispatch(changeTagStopLoading());
                bugsnagClient.notify(e)

            })
    }
}

const ungroupRows = (initialRow: number) => {
    const firebase = getFirebase();

    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => RootState) => {
        const state = getState()
        const projectId = getProjectId(state)
        const lookaheadId = getSelectedLookaheadId(state)

        const rowGroups = getRowGroups(state)
        const rowStarts = getRowGroupStarts(state)

        const rowStartSet = new Set<number>(rowStarts)

        if(!rowStartSet.has(initialRow)) {
            return
        }

        let found = null

        Object.keys(rowGroups).forEach(key => {
            const rowGroup = rowGroups[key]
            if(initialRow === rowGroup.start) {
                found = key
            }
        })

        if(!found) {
            return
        }

        batch(() => {
            
            dispatch(homeActions.openCircularProgressLoading());
        })

        await firebase.database().ref(`/projects/${projectId}/lookaheads/${lookaheadId}/row_groups/${found}/`)
        .remove().then(() => {
            dispatch(onRemoveClosedRowGroup(initialRow))
            
            dispatch(alertActions.success('Ungrouped'));

            dispatch(homeActions.closeCircularProgressLoading());
        })
        .catch((e: Error) => {
            console.error('error ungroupRows tags', e)

            dispatch(alertActions.error('Error Ungrouping'));
            dispatch(homeActions.closeCircularProgressLoading());
            bugsnagClient.notify(e)

        })
    }
}

const changeGroupSetting = (row:number, name?: string, color?: string) => {
    const firebase = getFirebase();

    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => RootState) => {
        const state = getState()
        const selectedRows = getSelectedRows(state)

        const projectId = getProjectId(state)
        const lookaheadId = getSelectedLookaheadId(state)
        const rowGroups = getRowGroups(state)

        let foundRow = null

        Object.keys(rowGroups).forEach(key=> {

            const rowGroup = rowGroups[key]
            if(rowGroup.start === row) {
                foundRow = key
            }
        })

        if(!foundRow) {
            return
        }

        firebase
            .database().ref(`/projects/${projectId}/lookaheads/${lookaheadId}/row_groups/${foundRow}`).update(clean({
                name,
                color
            }
        )).then(() => {

        })
        .catch((e: Error) => {
            console.error('error changing group setting', e)

            dispatch(alertActions.error('Error Changing Settings'));
            bugsnagClient.notify(e)

        })

    }
}

const findGroupsInNumberList = (sortedNumbers: number[]) => {

    return sortedNumbers.reduce((arr: number[], val, i, a) => {
        if (!i || val !== a[i - 1] + 1) arr.push([])

        arr[arr.length - 1].push(val);
        return arr;
      }, []) 
}

const moveRowGroup = (index: number | null, direction: string) => {
    const firebase = getFirebase();

    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => RootState) => {
        const state = getState()

        const projectId = getProjectId(state)
        const lookaheadId = getSelectedLookaheadId(state)
        const tags = getAllLookaheadTags(state)

        const tagsByIndex = _.groupBy(tags, 'indexId')
        
        const selectedRows = [...getSelectedRows(state)]

        if(index != null && !selectedRows.includes(index)) {
            selectedRows.push(index)
        }

        const updates = {}

        const sortedSelectedRows = selectedRows.sort((a:number, b:number) =>  a-b)

        const groupedNumbers = findGroupsInNumberList(sortedSelectedRows)
        const sortedGroupedNumbers = direction == 'up' ? groupedNumbers : groupedNumbers.reverse()
        sortedGroupedNumbers.forEach((group: number[]) => {
            const first = group[0]
            const last = group[group.length - 1]

            if(first == 0 && direction == 'up') {

            } else {
                group.forEach(tagIndex => {
                    const newIndex = direction == 'up' ? tagIndex - 1 : tagIndex + 1
                    const indexTags = !!tagsByIndex[tagIndex] ? tagsByIndex[tagIndex] : []
                    indexTags.forEach(tag => {
                        const tagId = tag.uid

                        updates[`/projects/${projectId}/lookaheads/${lookaheadId}/tags/${tagId}/indexId`] = newIndex

                    })
                })

                if(direction == 'up') {
                    batch(() => {
                        dispatch(onRowSelect(first -1))
                        dispatch(onRowUnSelect(last))
                    })
                } else {
                    batch(() => {
                        dispatch(onRowSelect(last + 1))
                        dispatch(onRowUnSelect(first))
                    })
                }
            }
        })


        return firebase.database().ref().update(updates)
            .then(() => {
                dispatch(alertActions.success('Rows Move'));

            })
            .catch((e: Error) => {
                console.error('Error Moving Roww', e)

                dispatch(alertActions.error('Error Moving Row'));
                //dispatch(changeTagStopLoading());
                bugsnagClient.notify(e)

            })
    }
}


const getStartMoveGroup = (direction:string )=>{

}

const moveGroup = (index: number, direction: string) => {
    const firebase = getFirebase();

    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => RootState) => {
        const state = getState()

        const projectId = getProjectId(state)
        const lookaheadId = getSelectedLookaheadId(state)
        const tags = getAllLookaheadTags(state)
        const rowGroups = getRowGroups(state)

        const tagsByIndex = _.groupBy(tags, 'indexId')
        

        const updates = moveGroupFunc(tags, rowGroups, direction, index, projectId, lookaheadId)

        return firebase.database().ref().update(updates)
        .then(() => {
            dispatch(alertActions.success('Group Moved'));

        })
        .catch((e: Error) => {
            console.error('Error Moving Group', e)

            dispatch(alertActions.error('Error Moving Group'));
            //dispatch(changeTagStopLoading());
            bugsnagClient.notify(e)

        })

    }
}


const deleteRowGroup = (index: number) => {
    const firebase = getFirebase();

    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => RootState) => {
        const state = getState()

        const projectId = getProjectId(state)
        const lookaheadId = getSelectedLookaheadId(state)
        
        const tags = getAllLookaheadTags(state)
        const rowGroups = getRowGroups(state)

        const updates = deleteRowGroupFunc(tags,  rowGroups, index, projectId, lookaheadId);


        if(!updates) {
            dispatch(alertActions.error("Row Must Be Empty"))
            return
        }

        return firebase.database().ref().update(updates)
            .then(() => {
                dispatch(alertActions.success('Row Deleted'));

            })
            .catch((e: Error) => {
                console.error('Error Adding Roww', e)

                dispatch(alertActions.error('Error Adding Row'));
                bugsnagClient.notify(e)

            })
    }
}

const addRowGroup = (index: number, direction: string) => {
    const firebase = getFirebase();

    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => RootState) => {
        const state = getState()

        const projectId = getProjectId(state)
        const lookaheadId = getSelectedLookaheadId(state)
        
        const tags = getAllLookaheadTags(state)
        const rowGroups = getRowGroups(state)

        const updates = addRowGroupFunc(tags,  rowGroups, direction, index, projectId, lookaheadId);

        return firebase.database().ref().update(updates)
            .then(() => {
                dispatch(alertActions.success('Row Added'));

            })
            .catch((e: Error) => {
                console.error('Error Adding Roww', e)

                dispatch(alertActions.error('Error Adding Row'));
                //dispatch(changeTagStopLoading());
                bugsnagClient.notify(e)

            })
    }
}


const groupRows = (initialRow: number) => {

    const firebase = getFirebase();

    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => RootState) => {
        const state = getState()
        const selectedRows = getSelectedRows(state)

        const projectId = getProjectId(state)
        const lookaheadId = getSelectedLookaheadId(state)
        const rowGroups = getRowGroups(state)
        const rowStarts = getLocalRowGroupStarts(state)

        const rowStartSet = new Set<number>(rowStarts)

        
        batch(() => {
            dispatch(onRowDeSelect())
            dispatch(homeActions.openCircularProgressLoading());
        })


        const selectedRowsSet = new Set<number>(selectedRows)
        let currentRow = initialRow

        let min = initialRow
        let max = initialRow
        const groupSet = new Set<number>()
        for(let i = 0; i < selectedRowsSet.size; i++) {
            if(selectedRowsSet.has(currentRow)) {
                groupSet.add(currentRow)
                
                if(currentRow > max) {
                    max = currentRow
                }
                
                currentRow ++;


            }
        }

        currentRow = initialRow

        for(let i = 0; i < selectedRowsSet.size; i++) {
            if(selectedRowsSet.has(currentRow)) {
                groupSet.add(currentRow)

                if(currentRow < max) {
                    min = currentRow
                }

                currentRow --;
            }
        }

        if(rowStartSet.has(min)) {
            dispatch(alertActions.error('Cannot Group'))
            dispatch(homeActions.closeCircularProgressLoading())

            return
        }

        let foundCorssBound = false

        Object.keys(rowGroups).forEach(key => {
            const rowGroup = rowGroups[key]
            if((rowGroup.start <= min && rowGroup.end >= min) && !(rowGroup.start <= max && rowGroup.end >= max))  {
                foundCorssBound = true
            }

            if((rowGroup.start <= max && rowGroup.end >= max) && !(rowGroup.start <= min && rowGroup.end >= min))  {
                foundCorssBound = true
            }
        })

        if( foundCorssBound) {
            dispatch(alertActions.error('Cannot Group'))
            dispatch(homeActions.closeCircularProgressLoading())
            return
        }

        const groupMap = Array.from<number>(groupSet).reduce((obj, cur) => {
            obj[cur] = true
            return obj
        }, {} as Record<number, boolean>)


        const updates: Record<string, any> = {}

        const ref = firebase.database().ref();
        
        const groupId:string = ref.push().key as string
        


        updates[`/projects/${projectId}/lookaheads/${lookaheadId}/row_groups/${groupId}/`] = {
            start: min,
            end: max
        }

        await firebase.database().ref().update(updates)
            .then(() => {
                dispatch(alertActions.success('Grouped'));

                dispatch(homeActions.closeCircularProgressLoading());
            })
            .catch((e: Error) => {
                console.error('error grouping tags', e)

                dispatch(alertActions.error('Error Grouping'));
                dispatch(homeActions.closeCircularProgressLoading());
                bugsnagClient.notify(e)

            })
        }
}

const saveCommitmentDay = (day:number) => {
    const firebase = getFirebase();

    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => RootState) => {
        const state = getState()
        const projectId = getProjectId(state)
        const lookaheadId = getSelectedLookaheadId(state)

        const updates: Record<string, string | number | object> = {}

        updates[`/projects/${projectId}/lookaheads/${lookaheadId}/commitment_day`] = day

        return firebase.database().ref().update(updates)
            .then(() => {
                dispatch(alertActions.success('Saved Weekly Commitment'));

            })
            .catch((e: Error) => {
                console.error('Error Creating Commitment', e)

                dispatch(alertActions.error('Error Creating Commitment'));
                //dispatch(changeTagStopLoading());
                bugsnagClient.notify(e)

            })
    }
}

const removeCommitmentDay = () => {
    const firebase = getFirebase();

    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => RootState) => {
        const state = getState()
        const projectId = getProjectId(state)
        const lookaheadId = getSelectedLookaheadId(state)

        return firebase.database().ref(`/projects/${projectId}/lookaheads/${lookaheadId}/commitment_day`).remove()
            .then(() => {
                dispatch(alertActions.success('Removed Weekly Commitment'));

            })
            .catch((e: Error) => {
                console.error('Error Removing Commitment', e)

                dispatch(alertActions.error('Error Removing Commitment'));
                //dispatch(changeTagStopLoading());
                bugsnagClient.notify(e)

            })
    }
}

const emailMRPBoard = (emailText:string, start:number, end:number) => {
    const firebase = getFirebase();

    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => RootState) => {
        const state = getState()
        
        const _emails = emailText.split(',').map(email => email.trim())
        const startDate = moment(start)
        const endDate = moment(end)
        const projectId = getProjectId(state)
        const lookaheadId = getSelectedLookaheadId(state)

        if(!startDate.isValid() || !endDate.isValid()) {
            return
        }


        try {

            await axios.post(`https://us-central1-constructionapp-c3a95.cloudfunctions.net/onEmailMRPBoard`, {
                    emails: _emails,
                    startDate: startDate.format('l'),
                    endDate: endDate.format('l'),
                    projectId: projectId,
                    lookaheadId: lookaheadId
            })
        } catch(e) {
            bugsnagClient.notify(e)
        }




    }
}

const undoTag = () => {
    const firebase = getFirebase();
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => RootState) => {

        const state = getState()
        
        const lookaheadId = getSelectedLookaheadId(state)
        const projectId = getProjectId(state)
        const commands = getUndoCommands(state)


        try {

            const response = await axios.post(`https://us-central1-constructionapp-c3a95.cloudfunctions.net/onUndoTags`, {
                    projectId: projectId,
                    lookaheadId: lookaheadId,
                    skips: commands.length
            })

            dispatch(onAddUndoCommand(response.data))
            dispatch(alertActions.success("Undone"))
        } catch(e) {

            bugsnagClient.notify(e)
            dispatch(alertActions.error("Error Undoning"))

        }

    }
}



const redoTag = () => {
    const firebase = getFirebase();

    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => RootState) => {
        const state = getState()
        
        const lookaheadId = getSelectedLookaheadId(state)
        const projectId = getProjectId(state)

        const undoCommands = [...getUndoCommands(state)]

        const command = undoCommands.shift()

        try {

            await axios.post(`https://us-central1-constructionapp-c3a95.cloudfunctions.net/onRedoTags`, {
                    projectId: projectId,
                    lookaheadId: lookaheadId,
                    command: command
            })

            dispatch(alertActions.success("ReDone"))

            dispatch(onShiftUndoCommand())

        } catch(e) {
            bugsnagClient.notify(e)
            console.error('redo error', e)
            dispatch(alertActions.error("Redo Error"))

        }

    }
}

const scrollCheck = (left:number, top:number, width:number, height:number, screenWidth:number, screenHeight: number) => {
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => RootState) => {

        if(left >= width - (2*screenWidth)) {

            dispatch(increaseBoardSize())
        }

        if(left < screenWidth) {
            dispatch(decreaseBoardSize())

        }

        return {

        }
    }
}

export const lookaheadActions = {
    scrollCheck,
    startLookaheadPlan,
    goToLookahead,
    lookaheadSelected,
    changeLookaheadTagColumn,
    lookaheadDialogOpen,
    lookaheadDialogClose,
    saveTag,
    saveTagIsMilestone,
    deleteTagColumn,
    onTagClicked,
    onTagDoubleClicked,
    lookaheadHistogramToggle,
    lookaheadSelectedTagsClearActionAsync,
    lookaheadTagsSelectedActionAsync,
    savePromiseTagsByDates,
    closeVarianceDialog,
    saveVariance,
    endActiveCommitment,
    huddleFilterChange,
    changeLookaheadTagStatus,
    showDeletePPCDialog,
    closeDeletePPCDialog,
    deleteCommitment,
    selectPPCCommitment,
    makeReadyPlanFilterByTrade,
    lockDownPlan,
    saveBatch,
    onRowSelect,
    onColumnSelect,
    groupRows,
    ungroupRows,
    onRowDeSelect,
    onToggleRowGroup,
    saveCommitmentDay,
    changeGroupSetting,
    onRemoveClosedRowGroup,
    createMRP,
    removeCommitmentDay ,
    emailMRPBoard,
    lookaheadForceRefreshAsync,
    lookaheadForceRefreshReset,
    addRowGroup,
    moveRowGroup,
    onRowUnSelect,
    moveGroup,
    undoTag,
    redoTag,
    onAddUndoCommand,
    onClearUndoCommand,
    deleteRowGroup,
    huddleFilterUp,
    huddleFilterDown,
    openReportDialog,
    closeReportDialog
}



// WEBPACK FOOTER //
// ./src/actions/lookahead.actions.ts